import { Nav, Footer } from "../components/Nav";
import { useSettings, resolveImage } from "../lib/settings";

const PORTRAIT_DEFAULT = "https://images.unsplash.com/photo-1716504628105-bd76d91e85f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBlbGVnYW50JTIwZmFzaGlvbiUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NTUwNzk1MHww&ixlib=rb-4.1.0&q=85";

export default function About() {
  const { settings } = useSettings();
  if (!settings) return <div className="p-10">Loading…</div>;
  const portrait = resolveImage(settings.about_portrait_path, PORTRAIT_DEFAULT);
  return (
    <div className="bg-[#FAFAFA]">
      <Nav />
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-32 grid grid-cols-1 md:grid-cols-12 gap-16 items-start">
        <div className="md:col-span-5">
          <img src={portrait} alt="Lata" className="w-full aspect-[3/4] object-cover" />
          <p className="overline mt-6"><span className="gold-line mr-3" />The Instructor</p>
        </div>
        <div className="md:col-span-7">
          <p className="overline mb-6">Meet Lata</p>
          <h1 className="font-serif-display font-light text-5xl md:text-6xl leading-[1.05]">
            {settings.about_headline_prefix} <span className="font-serif-italic italic text-[#D4AF37]">{settings.about_headline_italic}</span> {settings.about_headline_suffix}
          </h1>
          <p className="mt-8 text-lg text-[#0A0A0A] leading-relaxed max-w-lg">
            {settings.about_intro}
          </p>
          <div className="mt-16 space-y-8 max-w-lg">
            <div className="border-l-2 border-[#D4AF37] pl-6">
              <p className="overline">Practice</p>
              <p className="mt-2 leading-relaxed">{settings.about_practice}</p>
            </div>
            <div className="border-l-2 border-[#D4AF37] pl-6">
              <p className="overline">Brand</p>
              <p className="mt-2 leading-relaxed">{settings.about_teaching}</p>
              <a
                href="https://www.masobylata.in"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="maso-link"
                className="inline-flex items-center gap-2 mt-4 overline link-underline text-[#D4AF37]"
              >
                <span className="gold-line" />Visit M A S O — masobylata.in
              </a>
            </div>
            <div className="border-l-2 border-[#D4AF37] pl-6">
              <p className="overline">Belief</p>
              <p className="mt-2 leading-relaxed font-serif-italic italic">"{settings.about_belief}"</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
